import React     from 'react';
// import PropTypes from 'prop-types';

import * as S                from './upcomingPayments.module.scss';
// import { Pagination }        from '../../common/pagination';
import SM_PAYPAL             from '../../../assets/imgs/brand/paypal-icon.png';
import BANK_ICON             from '../../../assets/imgs/icons/icon-bank2.svg';
import { useGlobalCtx }      from '../../../context/ctx-hook';
// import * as Constants        from '../../../helpers/constants/constants';
import { maskEmail }         from '../../../helpers/masks';
import * as PaymentHelpers   from '../../../helpers/payment-helpers';
import { getShortDate }      from '../../../helpers/time-helpers';
import { ProductName }      from '../../common/product/prod-name';
import * as ProductSelectors from '../../../context/selectors/product-selectors';
import { getQknPriceWarn }    from '../../../helpers/skunotices-helpers';

const getPaymentType = (state, sub) => {
  const payMethods = state?.payMethods;
  if(payMethods?.length === 0) {
    return {};
  }

  let productLineDefault = false;
  payMethods.forEach(payment => {
    if(payment?.defaultForProductLines?.includes(sub?.productLineUriName)) {
      productLineDefault = payment;
    }
  });

  let defaultPay = false;
  payMethods.forEach(payment => {
    if(payment?.defaultMethod === true) {
      defaultPay = payment;
    }
  });

  return productLineDefault ? productLineDefault : defaultPay;
};

const getSubSumPrice = (subList, state) => {
  const subPriceList = subList.map(sub => {
    if(['quicken-us', 'quicken-ca'].includes(sub?.productLineUriName)) {
      const TIER_NOTICES = getQknPriceWarn(sub.tierUriName, sub.expireOn, state.country);
      if(TIER_NOTICES?.HAS_PRICE_UPDATE) {
        return TIER_NOTICES?.PRICE;
      } else {
        return ProductSelectors.getPriceBySku(state, sub.renewalSku, sub?.tierUriName);
      }
    } else {
      return ProductSelectors.getPriceBySku(state, sub.renewalSku, sub?.tierUriName);
    }
  });

  const totalSum = subPriceList.reduce((accumulator, price) => {
    const numericValue = parseFloat(price?.replace('$', ''));
    return Math.round((accumulator + numericValue) * 100) / 100;
  }, 0);
  return totalSum;
};

const getPaymentText = (payment) => {
  let text;
  if (payment.paymentMethodType === 'PAYPAL') {
    text = payment?.customerEmail ? maskEmail(payment?.customerEmail) : '';
  } else if (payment.paymentMethodType === 'CREDIT_CARD') {
    text = payment?.ccLast4 ? `****${payment?.ccLast4}` : '';
  } else if (payment.paymentMethodType === 'ACH') {
    text = 'Account Details';
  }
  return text;
};

const UpcomingPayments = () => {
  const {state} = useGlobalCtx();
  let upcomingRows = [];

  const ALL_COTERM_SUBS = Object.values(state.subscriptions).filter(sub => sub?.isCoTerminus && sub.autoRenew === true && sub.active === true);
  const COTERM_GRP = ALL_COTERM_SUBS?.length > 0 ? [ALL_COTERM_SUBS] : [];
  COTERM_GRP.map(cotermSubs => {
    const PAYMENT = getPaymentType(state, cotermSubs[0]);
    const priceDisplay = getSubSumPrice(cotermSubs, state);
    const priceIsNan = isNaN(priceDisplay);

    const subPaymentObject = {
      paymentMethod: PAYMENT?.paymentMethodType,
      ccLast4: PAYMENT?.ccLast4 || '',
      ccType: PAYMENT?.ccType || '',
      paymentText: getPaymentText(PAYMENT),
      subs: cotermSubs,
      renewalDate: getShortDate(cotermSubs[0]?.expireOn),
      price: !priceIsNan ? `$${priceDisplay}` : '$--.--'

    };

    upcomingRows.push(subPaymentObject);
  });

  const SINGLE_SUBS = Object.values(state.subscriptions).filter(sub => sub?.isCoTerminus === false && sub.autoRenew === true && sub.active === true);
  SINGLE_SUBS.map(sub => {
    const PAYMENT = getPaymentType(state, sub);
    const priceDisplay = getSubSumPrice([sub], state);
    const priceIsNan = isNaN(priceDisplay);

    const subPaymentObject = {
      paymentMethod: PAYMENT?.paymentMethodType,
      ccLast4: PAYMENT?.ccLast4 || '',
      ccType: PAYMENT?.ccType || '',
      paymentText: getPaymentText(PAYMENT),
      subs: [sub],
      renewalDate: getShortDate(sub?.expireOn),
      price: !priceIsNan ? `$${priceDisplay}` : '$--.--'
    };

    upcomingRows.push(subPaymentObject);
  });

  if (upcomingRows.length === 0) {
    return <div className={S.noHistory}>No upcoming payments at this time.</div>;
  }

  return (
    <>
      <div className={S.upcomingWrapper}>
        {upcomingRows.map((upcomingCharge, i) => {
          if (upcomingCharge.paymentMethod === 'ACH') {
            return (
              <div key={i} className={S.achRow}>
                <img className={S.bankIcon} role="presentation" src={BANK_ICON} alt="Bank Icon" />
                <span className={S.details}>ACH Direct Debit</span>
                <span className={S.description}>
                  {upcomingCharge?.subs?.map((product, i) =>
                    <span key={i} className={S.inlineProdName}>
                      {i > 0 && <>+</>}
                      <ProductName className={S.inlineProdName} sub={product} nameStyle={'textOnly'} />
                      <br />
                    </span>
                  )}
                </span>
                <span className={S.date}>{upcomingCharge.renewalDate}</span>
                <span className={S.price}>{upcomingCharge.price}</span>
              </div>
            );
          } else {
            return (
              <div key={i} className={S.paymentRow}>
                <div className={S.img}>
                  {upcomingCharge.paymentMethod === 'PAYPAL' && (
                    <img className={S.smPayPal} role="presentation" src={SM_PAYPAL} alt="PayPal Logo"/>
                  )}
                  {upcomingCharge.paymentMethod === 'CREDIT_CARD' && (
                    <img
                      role="presentation"
                      className={S.card}
                      src={PaymentHelpers.getCCLogo(upcomingCharge?.ccType)}
                      alt={`${upcomingCharge?.ccType} logo`}
                    />
                  )}
                </div>
                <span className={S.details} title={upcomingCharge.paymentMethod === 'PAYPAL' ? upcomingCharge.paymentText : null}>{upcomingCharge.paymentText}</span>
                <span className={S.description}>
                  {upcomingCharge?.subs?.map((product, i) =>
                    <span key={i} className={S.inlineProdName}>
                      {i > 0 && <>+</> }
                      <ProductName className={S.inlineProdName} sub={product} nameStyle={'textOnly'}/>
                      <br />
                    </span>
                  )}
                </span>
                <span className={S.date}>{upcomingCharge.renewalDate}</span>
                <span className={S.price}>{upcomingCharge.price}</span>
              </div>
            );
          }
        })}
      </div>
    </>
  );
};

UpcomingPayments.displayName = 'UpcomingPayments';

export { UpcomingPayments };